const submitOrderRouter = {
  path: '',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: '/submitOrder',
      name: 'SubmitOrder',
      meta: { title: '下单页面' },
      component: () => import(/* webpackChunkName: "order" */ '@/pages/submitOrder')
    }
  ]
}

export default submitOrderRouter
